import React, { useState } from 'react';
import styled from 'styled-components';
import FieldEditorCard from './FieldEditorCard';

interface Props {
  data: Record<string, any>;
  setData: (d: Record<string, any>) => void;
  tab: string;
  selectedKey: string | null;
  setSelectedKey: (k: string | null) => void;
}

const FieldPropertiesPanel = ({ data, setData, tab, selectedKey, setSelectedKey }: Props) => {
  const [showAll, setShowAll] = useState(false);
  const page = data[tab] || {};
  const keys = Object.keys(page).filter(k => k !== 'completed');

  const cardFor = (k: string) => (
    <FieldEditorCard
      key={k}
      data={data}
      setData={setData}
      tab={tab}
      fieldKey={k}
      selected={k === selectedKey}
      onSelect={setSelectedKey}
    />
  );

  let content: React.ReactNode;
  if (showAll) {
    content = keys.length === 0 ? <Empty>No fields on this page yet.</Empty> : keys.map(cardFor);
  } else if (!selectedKey || !page[selectedKey]) {
    content = <Empty>Select a field on the page to edit it, or tick “Show all fields”.</Empty>;
  } else {
    content = cardFor(selectedKey);
  }

  return (
    <Wrapper>
      <TopBar>
        <ShowAll>
          <input type="checkbox" checked={showAll} onChange={e => setShowAll(e.target.checked)} />
          <span>Show all fields ({keys.length})</span>
        </ShowAll>
      </TopBar>
      {content}
    </Wrapper>
  );
};

export default FieldPropertiesPanel;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const ShowAll = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--neutral-700);
  cursor: pointer;
`;

const Empty = styled.div`
  color: var(--neutral-500);
  font-size: 0.875rem;
  text-align: center;
  padding: 24px 8px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--neutral-0);
`;
